import { readFile } from "../../../helpers/cropImage";
import { useImageCropContext } from "../../../providers/ImageCropProvider";
import Button from "../../base/Button";
import Cropper from "../../cropper/Cropper";
import { RotationSlider, ZoomSlider } from "../../cropper/Sliders.jsx";
import { useI18N } from "common/hooks";
import { useDarkMode } from "@/hooks/useDarkMode";
import { useEffect, useRef } from "react";

const CoverPhotoCropModalContent = ({ handleDone, handleClose }) => {
  const { setImage } = useImageCropContext();
  const i18n = useI18N();
  const isDark = useDarkMode();

  const handleFileChange = async ({ target: { files } }) => {
    const file = files && files[0];
    const imageDataUrl = await readFile(file);
    setImage(imageDataUrl);
  };

  const firstFocusRef = useRef(null); // Reference for the element we need to set focus

  // Focus on the element when the component mounts
  useEffect(() => {
    if (firstFocusRef.current) {
      firstFocusRef.current.focus();
    }
  }, []);

  return (
    <div className="text-center relative">
      <div className="mb-5">
        <h1
          className="desktop-h1-xxsmall-bold text-center text-primary-800 dark:text-primary-150"
          tabIndex={0}
          ref={firstFocusRef} // Attach the ref here
        >
          {i18n.get("updateCoverPhoto")}
        </h1>
      </div>

      <div className="border border-dashed border-gray-200 p-6 rounded-lg">
        <div className="flex justify-center">
          <div className="crop-container mb-4">
            <Cropper />
          </div>
        </div>
        <ZoomSlider className="mb-4" />
        <RotationSlider className="mb-4" />
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="hidden"
          id="avatarInput"
          accept="image/*"
        />

        <div className="cursor-pointer">
          <div className="flex justify-center button-small-semi-bold text-links dark:text-primary-100 underline">
            <label htmlFor="avatarInput" className="cursor-pointer">
              {i18n.get("chooseADifferentPhoto")}
            </label>
          </div>
        </div>

        <div className="flex gap-2 mt-4">
          <Button disabled={false} className="w-full" onClick={handleDone}>
            {i18n.get("save")}
          </Button>
        </div>
      </div>

      <button onClick={handleClose} className="absolute top-0 left-0">
        {isDark ? (
          <img
            src="/images/Close_dark.svg"
            alt="Close"
            className="w-[24px] h-[24px]"
          />
        ) : (
          <img
            src="/images/Close.svg"
            alt="Close"
            className="w-[24px] h-[24px]"
          />
        )}
      </button>
    </div>
  );
};

export default CoverPhotoCropModalContent;
